var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E1251B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4,6.2h-8.3v8.7h0c0,0.1,0,0.1,0,0.2c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-0.1,0-0.1,0-0.2h0 V6.2H70.5v8.7h0c0,0.1,0,0.1,0,0.2c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-0.1,0-0.1,0-0.2h0V6.2H52.9v8.7h-0.1 c0,0.1,0,0.1,0,0.2c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-0.1,0-0.1,0-0.2h0V6.2H35.4v8.7h0c0,0.1,0,0.1,0,0.2 c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-0.1,0-0.1,0-0.2h0V6.2H17.8v8.7h0c0,0.1,0,0.1,0,0.2c0,1.6-1.3,2.9-2.9,2.9 c-1.6,0-2.9-1.3-2.9-2.9c0-0.1,0-0.1,0-0.2h0V6.2H3.6C1.6,6.2,0,7.8,0,9.8v18h100v-18C100,7.8,98.4,6.2,96.4,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1,2.9L88.1,2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9h0v3.3h5.9V2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,2.9L70.5,2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9h0v3.3h5.9V2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,2.9L52.9,2.9C52.9,1.3,51.6,0,50,0c-1.6,0-2.9,1.3-2.9,2.9h0v3.3h5.9V2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,2.9L35.4,2.9C35.3,1.3,34,0,32.4,0c-1.6,0-2.9,1.3-2.9,2.9h0v3.3h5.9V2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,2.9L17.8,2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9h0v3.3h5.9V2.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,33.6v62.7c0,2,1.6,3.6,3.6,3.6h92.7c2,0,3.6-1.6,3.6-3.6V33.6H0z M17.8,48.6c0-1.8,1.5-3.3,3.3-3.3h11 c1.8,0,3.3,1.5,3.3,3.3v11c0,1.8-1.5,3.3-3.3,3.3h-11c-1.8,0-3.3-1.5-3.3-3.3V48.6z M34.6,75.2l-8.5,8.1h0 c-0.5,0.4-1.1,0.7-1.7,0.7c-0.7,0-1.3-0.3-1.7-0.7L18.5,79l0,0c-0.6-0.6-0.9-1.5-0.6-2.4c0.2-0.9,0.9-1.5,1.8-1.8 c0.9-0.2,1.8,0,2.4,0.6l2.4,2.4l6.7-6.4c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.3,1.7,0.8v0c0.5,0.5,0.7,1.1,0.7,1.8 C35.4,74.1,35.1,74.7,34.6,75.2z M58.8,82.9c0,1.8-1.5,3.3-3.3,3.3h-11c-1.8,0-3.3-1.5-3.3-3.3v-11c0-1.8,1.5-3.3,3.3-3.3h11 c1.8,0,3.3,1.5,3.3,3.3V82.9z M58.8,59.6c0,1.8-1.5,3.3-3.3,3.3h-11c-1.8,0-3.3-1.5-3.3-3.3v-11c0-1.8,1.5-3.3,3.3-3.3h11 c1.8,0,3.3,1.5,3.3,3.3V59.6z M82.3,82.9c0,1.8-1.5,3.3-3.3,3.3h-11c-1.8,0-3.3-1.5-3.3-3.3v-11c0-1.8,1.5-3.3,3.3-3.3h11 c1.8,0,3.3,1.5,3.3,3.3V82.9z M82.3,59.6c0,1.8-1.5,3.3-3.3,3.3h-11c-1.8,0-3.3-1.5-3.3-3.3v-11c0-1.8,1.5-3.3,3.3-3.3h11 c1.8,0,3.3,1.5,3.3,3.3V59.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 51.2,
    className: "st0",
    width: 5.9,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 51.2,
    className: "st0",
    width: 5.9,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 51.2,
    className: "st0",
    width: 5.9,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 74.4,
    className: "st0",
    width: 5.9,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 74.4,
    className: "st0",
    width: 5.9,
    height: 5.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-98.5,24.8c0-13.7-11.1-24.8-24.8-24.8S-148,11.1-148,24.8c0,4.6,1.3,9,3.5,12.7l-3.3,12.1l12.1-3.3 c3.6,2.1,7.9,3.3,12.4,3.3C-109.6,49.6-98.5,38.5-98.5,24.8z M-119.9,16.3c-0.8-0.7-1.9-1.1-3.2-1.1c-1.3,0-2.4,0.4-3.2,1.1 c-0.9,0.7-1.5,1.9-1.8,3.4l-4.7-0.6c0.1-2.2,1.1-4,2.8-5.5c1.7-1.5,3.9-2.3,6.7-2.3c2.9,0,5.2,0.8,7,2.3c1.7,1.5,2.6,3.3,2.6,5.3 c0,1.1-0.3,2.2-0.9,3.2c-0.6,1-2,2.4-4.1,4.1c-1.1,0.9-1.7,1.6-2,2.2c-0.3,0.5-0.4,1.5-0.4,2.9h-4.6c0-0.7,0-1.1,0-1.2 c0-1.5,0.2-2.7,0.7-3.7c0.5-1,1.5-2,3-3.3c1.5-1.2,2.4-2,2.7-2.4c0.4-0.6,0.7-1.2,0.7-2C-118.7,17.9-119.1,17-119.9,16.3z  M-125.7,33.1h5.1v5.1h-5.1V33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-83,43.6c0-8.3-4.7-15.4-11.5-19c0,0.1,0,0.1,0,0.2c0,15.8-12.9,28.7-28.7,28.7c-0.1,0-0.2,0-0.3,0 c3.6,6.9,10.8,11.6,19,11.6c4,0,7.7-1.1,10.9-3l10.5,3l-3-10.5C-84.1,51.4-83,47.6-83,43.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.6003a16f0f1785bcf9ac542a4d9c25f6.svg";
export { ForwardRef as ReactComponent };